import ApiService from "@/common/api/api.service";

let endpoint = "ProjetoGestao";

const CronogramaEtapa = {
    
    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvarEtapa(form) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${endpoint}/realizar-etapa`, form.etapa).then(() => {
                if(form.etapa.prevista){
                    resolve();
                }

                ApiService.put(`${endpoint}/etapa`, form.etapa).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },


    salvarSubetapa(form) {
        return new Promise((resolve, reject) => {
            if(form.cronogramaEtapaId){
                form.mesInicial = form.mesInicialRealizado;
                form.mesFinal = form.mesFinalRealizado;

                ApiService.post(`${endpoint}/subetapa`, form).then(res => {
                    resolve(res.data.data);
                }).catch(() => {
                    reject();
                })  
                return;
            }

            ApiService.put(`${endpoint}/realizar-subetapa`, form).then(() => {
                if(form.prevista){
                    resolve();
                }

                ApiService.put(`${endpoint}/subetapa`, form).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },
    
    salvarRelatorio(form) {
        return new Promise((resolve, reject) => {
            if(form.cronogramaEtapaId){
                form.mesFinal = form.mesFinalRealizado;
                ApiService.post(`${endpoint}/relatorio-etapa`, form).then(res => {
                    resolve(res.data.data);
                }).catch(() => {
                    reject();
                })  
                return;
            }

            ApiService.put(`${endpoint}/realizar-relatorio-etapa`, form).then(() => {
                if(form.previsto){
                    resolve();
                }

                ApiService.put(`${endpoint}/relatorio-etapa`, form).then(() => {
                    resolve();
                }).catch(() => {
                    reject();
                })    
            }).catch(() => {
                reject();
            })
        });
    },

    removerRelatorio(id) {
        return ApiService.delete(`${endpoint}/relatorio-etapa?id=${id}`);
    },

    removerSubetapa(id) {
        return ApiService.delete(`${endpoint}/subetapa?id=${id}`);
    },

    salvarDetalhamento(form, realizado) {
        return ApiService.put(`${endpoint}/cronograma-etapa-${realizado ? 'realizado' : 'previsto'}`, form);
    },

    excluirCronograma(id) {
        return ApiService.delete(`${endpoint}/cronograma-etapa?id=${id}`);
    },

    listarCronograma(id) {
        return ApiService.get(`ProjetoGestao/cronograma-etapa?projetoId=${id}`);
    },

    uploadRelatorio(form){
        return ApiService.put(`${endpoint}/adicionar-arquivo-relatorio`, form);
    },

    aprovarRelatorio(id){
        return ApiService.put(`${endpoint}/aprovar-relatorio-etapa?id=${id}`);
    },

    salvarCronograma(form){
        return ApiService.post(`${endpoint}/cronograma-etapa`, form);
    }

}

export default CronogramaEtapa;
